export default [
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      title: '关于我们',
    },
    redirect: '/aboutUs/comIntroduction',
    component: () => import('../views/aboutUs/index.vue'),
    children: [
      {
        path: 'comIntroduction',
        name: 'comIntroduction',
        meta: { title: '公司介绍' },
        component: () => import('../views/aboutUs/comIntroduction.vue'),
      },
      {
        path: 'aboutUs1',
        name: 'aboutUs1',
        meta: { title: '公司荣誉' },
      },
      {
        path: 'aboutUs2',
        name: 'aboutUs2',
        meta: { title: '公司新闻' },
      },
      {
        path: 'aboutUs3',
        name: 'aboutUs3',
        meta: { title: '社会责任' },
      },
      {
        path: 'aboutUs4',
        name: 'aboutUs4',
        meta: { title: '诚聘英才' },
      },
      {
        path: 'aboutUs5',
        name: 'aboutUs5',
        meta: { title: '联系我们' },
      },
    ],
  },
];
